export default __webpack_public_path__ + "static/media/blur_more.c8eb04f7.png";